import { axiosModules } from "@qubit-utill/src";

export default {
  // 사용자 환경 등록 설정 목록 조회
  getUserSettingInfo: () =>
    axiosModules.get(`/pcustomer/userpreferences`, {
      servicePreferencesId: "isUseCursorMark",
    }),
};
